import { useApi } from '../services';

export const useGetLimitConsumption = (idOperation) => useApi(
  `v2/credit-limit/${idOperation}/limit-consumption`,
  'GET',
  {},
  {}
);

export const useCheckConsumption = (idOperation) => useApi(
  `v2/credit-limit/${idOperation}/check-consumption`,
  'GET',
  {},
  {},
  true
);